import { render, staticRenderFns, recyclableRender, components } from "./privacy.vue?vue&type=template&id=1ce02cbb&scoped=true&"
var renderjs
import script from "./privacy.vue?vue&type=script&lang=js&"
export * from "./privacy.vue?vue&type=script&lang=js&"
import style0 from "./privacy.vue?vue&type=style&index=0&id=1ce02cbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce02cbb",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/login/register/privacy.vue"
export default component.exports